export function createAdObject(
  adName: string,
  adId: string,
  adPosition: number,
  adLength: number,
  playerName: string
) {
  return {
    'media.ad.id': adId,
    'media.ad.length': adLength,
    'media.ad.name': adName,
    'media.ad.podPosition': adPosition,
    'media.ad.playerName': playerName,
  };
}
